// Faixas Unicode de emojis, pictogramas, símbolos e seus modificadores (seletor de variação, ZWJ, tons de pele, bandeiras)
const REGEX_EMOJI =
  /[\u{1F000}-\u{1FAFF}\u{2190}-\u{21FF}\u{2300}-\u{23FF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{203C}\u{2049}\u{2122}\u{2139}\u{3030}\u{303D}\u{FE0E}\u{FE0F}\u{200D}\u{20E3}\u{E0020}-\u{E007F}]/gu;

const TIPOS_DE_TEXTO = ["text", "search", "email", "tel", "url"];

export function removerEmojis(texto) {
  return String(texto ?? "").replace(REGEX_EMOJI, "");
}

function ehCampoDeTexto(el) {
  if (!el) return false;
  if (el.tagName === "TEXTAREA") return true;
  return el.tagName === "INPUT" && TIPOS_DE_TEXTO.includes(el.type);
}

function limparCampo(evento) {
  const campo = evento.target;
  // Durante a composição (IME) o valor ainda não está finalizado
  if (evento.isComposing || !ehCampoDeTexto(campo)) return;

  const valor = campo.value;
  const limpo = removerEmojis(valor);
  if (limpo === valor) return;

  // Mantém o cursor na posição correta após remover os emojis
  const cursor = campo.selectionStart;
  const removidosAntesDoCursor =
    cursor == null
      ? 0
      : valor.slice(0, cursor).length - removerEmojis(valor.slice(0, cursor)).length;
  campo.value = limpo;
  if (cursor != null) {
    const novaPosicao = Math.max(0, cursor - removidosAntesDoCursor);
    campo.setSelectionRange(novaPosicao, novaPosicao);
  }
}

// Instala o filtro em um elemento raiz. Executa na fase de captura, antes de o v-model ler o valor.
// Retorna a função que remove o filtro.
export default function bloquearEmojis(raiz) {
  raiz.addEventListener("input", limparCampo, true);
  return () => raiz.removeEventListener("input", limparCampo, true);
}
